<template>
  <div>
    <button class="btn bg-info text-white" @click="handleViewStatement" :disabled="isLoading">
      <i :class="isLoading ? 'fas fa-spinner fa-spin' : actionButtonIcon"></i>
      {{ isLoading ? 'Loading...' : (callToActionButtonLabel || 'Action') }}
    </button>
  </div>
</template>

<script>
import {useCustomerStatement} from "../../composables/useCustomerStatement";
import {handleError} from "../../utils/notification.utils";

export default {
  name: "ViewCustomerStatementButton",
  props: {
    customerId: {
      type: String,
      required: true
    },
    callToActionButtonLabel: {
      type: String,
      default: 'View Statement'
    },
    actionButtonIcon: {
      type: String,
      default: 'fa fa-eye'
    }
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async handleViewStatement() {
      this.isLoading = true;
      const {getStatementAccountId} = useCustomerStatement();
      try {
        const accountId = await getStatementAccountId(this.customerId);
        if (accountId) {
          await this.$router.push(`/customers/${this.customerId}/accounts/${accountId}/statement`);
        }
      } catch (e) {
        await handleError(e);
      } finally {
        this.isLoading = false;
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/ViewCustomerStatementButton.vue